
import { Actions } from "@/store/enums/StoreEnums";
import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Names } from "@/core/config/enums/SitePaths";

export default defineComponent({
  name: "InnerCategoryComponent",
  props: {
    category: Object,
  },
  setup(props) {
    const openCollapse = ref(false);
    const store = useStore();
    const toggleModal = (id) => {
      store.dispatch(Actions.SETUP_FORM_COMPONENT_OR_MODAL, {
        key: Names.CATEGORIES,
        id: id,
      });

      //store.dispatch(Actions.TOGGLE_IS_MODAL_OPEN);
    };
    const toggleCollapse = () => {
      openCollapse.value = !openCollapse.value;
    };
    const getOpenCollapse = computed(() => {
      return openCollapse.value;
    });
    const getInlineSearch = computed(() => {
      return store.getters.getInlineSearch({ key: Names.CATEGORIES });
    });
    const getSearchTerm = computed(() => {
      return store.getters.getSearchTerm({ key: Names.CATEGORIES });
    });

    const deleteItem = (id, index, hasChildren) => {
      Swal.fire({
        html: !hasChildren
          ? "Are you sure you want to delete this category?"
          : "The category you are trying to delete, has children categories.\
         <br><br>Are you sure you want to delete the category with its children?",
        icon: "error",
        buttonsStyling: true,
        showCancelButton: true,
        showConfirmButton: true,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn",
        },
      }).then(function (deleted) {
        // Go to page after successfully login
        if (deleted.isConfirmed) {
          store.dispatch(Actions.DELETE_ITEM, {
            key: Names.CATEGORIES,
            id: id,
          });
        }
        //
      });

      //store.dispatch(Actions.TOGGLE_IS_MODAL_OPEN);
    };
    return {
      toggleModal,
      toggleCollapse,
      getOpenCollapse,
      getSearchTerm,
      getInlineSearch,
      deleteItem,
      Names,
    };
  },
});
